import React from 'react';
import classnames from 'classnames';
import './HomeWorkTable.scss';
import BrowserLink from '../../../../components/BrowserLink';

export function HomeWorkTable({ disabled = false, data, ...props }) {
  return (
    <table className={classnames('HomeWorksTable', { disabled })}>
      <thead>
        <tr>
          {!disabled && (
            <th />
          )}
          <th>Date</th>
          <th>Format</th>
          <th>Position</th>
          <th>Opp. Pos.</th>
          <th>IP/OOP</th>
          <th>Preflop</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row) => (
          <Row disabled={disabled} row={row} key={row.id} />
        ))}
      </tbody>
    </table>
  );
}

function Row({ disabled = false, row }) {
  const link = disabled ? '#' : row.link;

  return (
    <tr>
      {!disabled && (
        <td>
          <img src="https://poker-coaching.s3.amazonaws.com/images/homework/details_open.png" alt="+" />
        </td>
      )}
      <td className="title">
        <BrowserLink href={link}>{row.title}</BrowserLink>
      </td>
      <td>
        <BrowserLink href={link}>{row.format}</BrowserLink>
      </td>
      <td>
        <BrowserLink href={link}>{row.my_pos}</BrowserLink>
      </td>
      <td>
        <BrowserLink href={link}>{row.opp_pos}</BrowserLink>
      </td>
      <td>
        <BrowserLink href={link}>{row.ip_oop}</BrowserLink>
      </td>
      <td>
        <BrowserLink href={link}>{row.preflop}</BrowserLink>
      </td>
      <td>
        <BrowserLink href={link} className="view-btn">View</BrowserLink>
      </td>
    </tr>
  );
}

